<template>
    <div class="overlay-login">
        <div class="xinhua-logo">
            <img src="@/assets/images/logo.png" />
        </div>
        <div class="row row-mobile">
            <span class="mobile-pre">+86</span>
            <input
                class="input-mobile"
                placeholder="请输入手机号"
                type="number"
                v-model="mobile"
            />
            <div class="btn-cancel"></div>
        </div>
        <div class="row row-code" style="height: auto;">
            <span class="nc_toast">滑动验证</span>
        </div>
        <div class="row row-code" style="height: auto; margin-top: 0.35rem;">
            <div id="slide-bar" class="nc-container"></div>
        </div>
        <div class="row row-code">
            <input
                class="input-code"
                placeholder="请输入验证码"
                type="number"
                v-model="code"
            />
            <span class="btn-getcode" :class="{gray: !canGetCode || interval > 0}" @click="send"> {{ interval ? interval + '秒后重试' : '发送验证码' }} </span>
        </div>
        <div class="agreement">
            <van-checkbox class="icon-check" shape="square" v-model="agreement"></van-checkbox>
            <section>
                登录即代表您已阅读并同意
                <a href="https://my-h5news.app.xinhuanet.com/h5/agreement.html"
                    >《用户协议》</a
                >
                和
                <a href="https://my-h5news.app.xinhuanet.com/h5/privacy.html"
                    >《隐私政策》</a
                >
            </section>
        </div>
        <div class="btn-login active" @click="submit">登录</div>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>

<style scoped>
.nc_toast {
    flex-shrink: 0;
    font-size: 18px;
    color: #6B727A;
    margin-right: 8px;
}
@media (max-width: 300px) {
    .nc_toast {
        display: none;
    }
}
.nc-container {
    flex: 1;
    min-width: 0;
    width: 100%;
    max-width: 100%;
}
</style>
<style>
.overlay-login .btn_slide,
.overlay-login .btn_ok {
    height: 100% !important;
}
.overlay-login #slide-bar {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
}
.overlay-login #slide-bar > div {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
}
</style>